import { APIResourceService } from '@/core/services/APIService'
import Role from '@/core/resources/Role'
import { buildException } from '@/core/exceptions'

export class RoleService extends APIResourceService<Role> {
  constructor() {
    super(Role)
  }

  uploadUsersGuide(item: Role, file: any, token: string): Promise<boolean> {
    Object.defineProperty(file, 'name', { writable: true })
    file.name = 'USERGUIDE_' + item.name + '.pdf'
    const formData = new FormData()
    formData.append('file', file)

    return this.client
      .post('roles/' + item.name + '/upload_userguide', formData, token)
      .then(() => true)
      .catch((err) => {
        throw buildException(err)
      })
  }
}
